import { FC } from "react";
import { useTranslation, withTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { Link } from "react-router";

import LanguageSelect from "@components/LanguageSelect/LanguageSelect";
import { AVAILIO_LOGO } from "@constants/assets";
import { routeEnum, supportEnum, userInfoEnum } from "@enums/route.enum";
import authSlice from "@slices/auth.slice";
import organisationSlice from "@slices/organisation.slice";
import { RootState } from "@store/index";

import modalSlice from "../../slices/modal.slice";

const HeaderComponent: FC = () => {
  const { isAuthenticated } = useSelector((State: RootState) => State.local);

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { pathname } = useLocation();

  const onUserLogoClick = () => {
    if (isAuthenticated) {
      navigate(userInfoEnum.UserInfo);
    } else {
      resetPath();
    }
  };

  const resetLocationUnitStore = () => {
    dispatch(organisationSlice.actions.changeLocationId({ id: "0" }));
    dispatch(organisationSlice.actions.changeResourceId({ id: "0" }));
  };

  const resetPath = () => {
    if (pathname.includes(supportEnum.Auth)) {
      dispatch(
        authSlice.actions.passParams({ userEmail: "", verificationCode: "" })
      );
      navigate("/", { replace: true });
    }
    dispatch(modalSlice.actions.updateLoginModal(true));
  };

  return (
    <header>
      <div className=" fg-header-main" data-testid={"header-test"}>
        <div className="container">
          {pathname !== routeEnum.Home &&
            !pathname.includes(supportEnum.Auth) && (
              <button
                className="btn fg-btn fg-btn-back"
                onClick={() => {
                  navigate(-1);
                  resetLocationUnitStore();
                }}
                data-testid="headerBackButton"
              >
                {t("back")}
              </button>
            )}

          <div className="fg-header-block" data-testid="header-block">
            <Link
              to="/"
              onClick={resetLocationUnitStore}
              data-testid="fairgate-image"
            >
              <img
                src={AVAILIO_LOGO}
                className="fg-logo-img"
                alt="Availio logo"
              />
            </Link>

            <div className="fg-header-right" data-testid="header-right">
              {!isAuthenticated && (
                <button
                  className="btn btn-link fg-link-override fg-btn-header-reg"
                  onClick={() =>
                    dispatch(modalSlice.actions.updateRegisterModal(true))
                  }
                  data-testid={"registerButton"}
                >
                  {t("registerYourself")}
                </button>
              )}
              {isAuthenticated ? (
                <span
                  data-testid={"userLogo"}
                  onClick={onUserLogoClick}
                  className={"fg-button-override fg-user-circle fg-bg-success"}
                  role="button"
                  aria-hidden="true"
                >
                  <i className="fa-solid fa-user-check"></i>
                </span>
              ) : (
                <button
                  data-testid={"userLogo"}
                  type="button"
                  className="btn btn-link fg-link-override"
                  onClick={onUserLogoClick}
                  aria-hidden="true"
                >
                  {t("login")}
                </button>
              )}

              <LanguageSelect />
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

const Header = withTranslation()(HeaderComponent);

export default Header;
